import chartDefaultColors from './chartDefaultColors'
import styles from './sharedStyles.module.scss'

const sharedConfig = {
  title: null,
  exporting: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  chart: {
    backgroundColor: 'transparent',
  },
  colors: chartDefaultColors,
  yAxis: {
    className: styles.yAxis,
    labels: {
      useHTML: true,
      style: { color: 'revert-layer', fontFamily: 'inherit', fontSize: 'inherit' },
    },
    title: {
      title: '',
      enabled: false,
    },
    gridLineWidth: 0,
  },
  xAxis: {
    className: styles.xAxis,
    labels: {
      useHTML: true,
      style: { color: 'revert-layer', fontFamily: 'revert-layer', fontSize: 'inherit' },
    },
    tickWidth: 0,
  },
  legend: {
    className: styles.legend,
    layout: 'horizontal',
    align: 'center',
    verticalAlign: 'bottom',
    enabled: false,
  },
  tooltip: {
    useHtml: true,
    className: styles.tooltip,
    shadow: {
      color: 'rgba(0, 0, 0, 0.2)',
      width: 8,
      offsetX: 0,
      offsetY: 0,
    },
  },
  series: {
    className: styles.legend,
    label: {
      connectorAllowed: false,
    },
  },
}

export default sharedConfig
